import * as amplitude from '@amplitude/analytics-browser';
import { type BaseEvent, type EventOptions } from '@amplitude/analytics-types';
import { useCallback, useEffect } from 'react';

type TrackEvent = (
  eventName: BaseEvent | string,
  eventProperties?: Record<string, any>,
  options?: EventOptions,
) => void;

export const useAmplitude = () => {
  const trackEvent: TrackEvent = useCallback(
    (eventName, eventProperties, options) => {
      if (process.env.NODE_ENV === 'development') {
        // eslint-disable-next-line no-console
        console.debug(`Amplitude event: ${eventName}`, eventProperties);
      }

      return amplitude.track(eventName, eventProperties, options);
    },
    [],
  );

  return {
    trackEvent,
  };
};

export const useTrackEvent = (...args: Parameters<TrackEvent>) => {
  const { trackEvent } = useAmplitude();

  useEffect(() => {
    trackEvent(...args);
  }, [trackEvent, args]);
};

export const useTrackEventOnce = (...args: Parameters<TrackEvent>) => {
  const { trackEvent } = useAmplitude();

  useEffect(() => {
    trackEvent(...args);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
